import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { FileUploadResultModalProps } from "../../download-upload.types";

@Component({
    selector: "app-smartfleet-file-upload-result-modal",
    templateUrl: "./file-upload-result-modal.component.html",
    styleUrls: ["./file-upload-result-modal.component.scss"],
    standalone: false
})
export class FileUploadResultModalComponent implements OnInit {
  message: string;

  constructor(
    public dialogRef: MatDialogRef<FileUploadResultModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadResultModalProps,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.setPageInfos();
  }

  setPageInfos() {
    if (!this.data?.response?.length) {
      this.message = this.translateService.instant(
        "file-upload-result-modal.success"
      );
    } else {
      this.message = this.translateService.instant(
        "file-upload-result-modal.error"
      );
    }
  }

  close() {
    if (!this.data?.response?.length) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close(false);
    }
  }
}
